import React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import { IntlError, IntlErrorCode } from '@formatjs/intl';

import { ReduxState } from '../../types/app';

/** Без этого FormatJS шумит в консоли на каждый ключ, которого нет в ru/en с бэкенда. */
function defaultIntlOnError(err: Error): void {
  if (
    err instanceof IntlError &&
    err.code === IntlErrorCode.MISSING_TRANSLATION
  ) {
    return;
  }
  console.error(err);
}

function IntlProviderWithMutedMissingTranslations(
  props: React.ComponentProps<typeof IntlProvider>
) {
  const { onError, locale, ...rest } = props;
  return React.createElement(IntlProvider, {
    key: locale,
    locale,
    ...rest,
    onError: onError ?? defaultIntlOnError,
  });
}

function defaultSelector(state: ReduxState) {
  return state.intl;
}

const mapStateToProps = (
  state: ReduxState,
  { intlSelector = defaultSelector }
) => intlSelector(state);

export default connect(mapStateToProps)(
  IntlProviderWithMutedMissingTranslations
) as any;
